import StatusHandler from "Helpers/StatusHandler";
import UnitBarService from "Services/http/endpoints/design/UntiBarService";
import PatternService from "Services/http/endpoints/pattern/PatternService";
import {
  SELECT_TOOL,
  POP_LIST,
  UNIT_INFO,
  DRAWER_RESULT,
  CHECK_ADDONS,
  ADDONS_INFO,
  SAVE_DASTE_PROFILE_LIST_TYPE_DESIGN,
  OLGU_DATA_SEARCH_DESIGN,
  SAVE_ALL_OLGU_DATA_DESIGN,
  NEW_UNIT_INFO, TOGGLE_UNIT_DRAWER, SELECTED_UNIT_COUNT,
} from "Stores/actionTypes";
import DrawerService from "../../Services/http/endpoints/design/DrawerService";

export const getDesignUnitList = (params) => {
  return async () => {
    try {
      const response = await UnitBarService.getUnitList(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data;
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const getRebuildUnit = (params) => {
  return async (dispatch) => {
    const response = await UnitBarService.getRebuildUnit(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      const unitRebuildDetails = response.data.Value;
      dispatch({
        type: DRAWER_RESULT,
        drawerResult: unitRebuildDetails,
      });
      dispatch({
        type: UNIT_INFO,
        unitInfo:JSON.parse( unitRebuildDetails.T)[0],
      });
      return unitRebuildDetails;
    }
  };
};

export const getUnitInfo = (params) => {
  return async (dispatch) => {
    const response = await DrawerService.generateUnit(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      const unitInfo = response.data.Value;
      dispatch({
        type: UNIT_INFO,
        unitInfo,
      });
      return unitInfo;
    }
  };
};

export const getPopList = (params) => {
  return async (dispatch) => {
    const response = await DrawerService.allPopWithBrand(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      const popList = response.data.Value;
      dispatch({
        type: POP_LIST,
        popList,
      });
    }
  };
};

export const onSelectTools = (selectedTool) => (dispatch) => {
  dispatch({
    type: SELECT_TOOL,
    selectedTool: selectedTool,
  });
};

export const checkAddons = (name) => (dispatch) => {
  dispatch({
    type: CHECK_ADDONS,
    checkAddon: name,
  });
};

export const resetAddons = () => (dispatch) => {
  dispatch({
    type: CHECK_ADDONS,
    checkAddon: null,
  });
};

export const getAddonsInfo = (info) => (dispatch) => {
  dispatch({
    type: ADDONS_INFO,
    addonsInfo: info,
  });
};

export const getGroupProfileWithTypeDesign = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getGroupProfileWithType(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt) => {
          return {
            ...dt,
            label: dt.Name,
            value: dt.Id,
          };
        });

        dispatch({
          type: SAVE_DASTE_PROFILE_LIST_TYPE_DESIGN,
          dasteProfileListWithTypeDesign: updateData,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeOlguSearchDesign = (allOlguDataSearch) => (dispatch) => {
  dispatch({
    type: OLGU_DATA_SEARCH_DESIGN,
    allOlguDataSearchDesign: allOlguDataSearch,
  });
};

export const getOlguListDesign = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getOlguList(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt, i) => {
          return {
            ...dt,
            num: i,
          };
        });
        dispatch({
          type: SAVE_ALL_OLGU_DATA_DESIGN,
          allOlguDataDesign: updateData,
          allOlguDataPaginationDesign: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const saveNewUnitInfo = (newUnitInfo) => (dispatch) => {
  dispatch({
    type: NEW_UNIT_INFO,
    newUnitInfo,
  });
};

export const toggleUnitDrawer = (isOpenUnitDrawer) => (dispatch) => {
  dispatch({
    type: TOGGLE_UNIT_DRAWER,
    isOpenUnitDrawer: isOpenUnitDrawer,
  });
};

export const setSelectedUnitCount = (selectedUnitCount) => (dispatch) => {
  dispatch({
    type: SELECTED_UNIT_COUNT,
    selectedUnitCount: selectedUnitCount,
  });
};
